import { render, staticRenderFns } from "./RewardSpendSection.vue?vue&type=template&id=6f0e5c15&scoped=true&"
import script from "./RewardSpendSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./RewardSpendSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./RewardSpendSection.vue?vue&type=style&index=0&id=6f0e5c15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e5c15",
  null
  
)

export default component.exports